import "./ControlBar.css";
import { Panel } from "../Panel/Panel.jsx";

export function ControlBar({ start = null, middle = null, end = null, className = "", boxed = true }) {
  const hasStart = start !== null;
  const hasMiddle = middle !== null;
  const hasEnd = end !== null;
  const layoutKey = [
    hasStart ? "start" : null,
    hasMiddle ? "middle" : null,
    hasEnd ? "end" : null
  ].filter(Boolean).join("-");
  const controlBarClassName = className ? `control-bar ${className}` : "control-bar";
  const content = (
    <>
      {hasStart ? <div class="control-bar-region start">{start}</div> : null}
      {hasMiddle ? <div class="control-bar-region middle">{middle}</div> : null}
      {hasEnd ? <div class="control-bar-region end">{end}</div> : null}
    </>
  );

  if (!boxed) {
    return <div class={controlBarClassName} data-layout={layoutKey}>{content}</div>;
  }

  return <Panel className={controlBarClassName} data-layout={layoutKey}>{content}</Panel>;
}
